module.exports = __webpack_public_path__ + "static/media/bootstrap.bd476acf.png";